require('bootstrap/dist/js/bootstrap.min');
import initializeFancybox from './fancybox';
initializeFancybox();
